'use client';

import { c as _c } from "react/compiler-runtime";
import { Play } from 'lucide-react';
type AdResumeOverlayProps = {
  onResume: () => void;
};
export default function AdResumeOverlay(t0) {
  const $ = _c(8);
  const {
    onResume
  } = t0;
  let t1;
  if ($[0] !== onResume) {
    t1 = e => {
      e.stopPropagation();
      onResume();
    };
    $[0] = onResume;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Play className="size-6 fill-black" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <button type="button" className="rounded-full bg-white/90 px-6 py-3 text-sm font-semibold text-black hover:bg-white" onClick={t1}>{t2}</button>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== onResume || $[6] !== t3) {
    t4 = <div className="absolute inset-0 z-interactive flex cursor-pointer items-center justify-center bg-black/60" onClick={onResume}>{t3}</div>;
    $[5] = onResume;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}